//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import InspectionTemplatePointDrawer from "./modules/InspectionTemplatePointDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: "InspectionTemplatePointList",
  mixins: [JeecgListMixin],
  components: {
    InspectionTemplatePointDrawer: InspectionTemplatePointDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/inspection/template/point',
      pageTitle: '巡检模板点位管理',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'parentId',
        colName: 'parent_id',
        title: '父级id',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'templateId',
        colName: 'template_id',
        title: '模板id',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '巡检点名称',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'remark',
        colName: 'remark',
        title: '巡检点说明',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'coordinate',
        colName: 'coordinate',
        title: '坐标（预留）',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'path',
        colName: 'path',
        title: '路径',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'status',
        colName: 'status',
        title: '状态',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'delFlag',
        colName: 'del_flag',
        title: '删除状态',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'sort',
        colName: 'sort',
        title: '排序号',
        align: "center",
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};